export const COMPANY_NAME = "Craniometrix";
export const APP_BASE_NAME = "Operators";
export const APP_STAGE_LABEL = import.meta.env.DEV ? "Dev" : "v1";
export const APP_DISPLAY_NAME = APP_BASE_NAME;
export const APP_VERSION = import.meta.env.APP_VERSION || "0.0.0";
